import React, { useState } from "react";
import {
  Box,
  Paper,
  TextField,
  Button,
  Typography,
  InputAdornment,
  Link,
  Alert,
  CircularProgress,
} from "@mui/material";

import { EmailOutlined } from "@mui/icons-material";

import { forgotPassword } from "../api/authApi";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSuccess("");

    if (!email) {
      setError("Please enter your email address.");
      return;
    }

    try {
      setLoading(true);
      const data = await forgotPassword(email);
      setSuccess(data.message);
    } catch (err) {
      setError(
        err?.response?.data?.message || "Unable to process your request. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #eef6ff 0%, #f5fbfa 50%, #ffffff 100%)",
        px: 1,
      }}
    >
      <Paper
        elevation={8}
        sx={{
          width: "100%",
          maxWidth: 380,
          p: { xs: 3, sm: 4 },
          borderRadius: 3,
        }}
      >
        <Typography variant="h6" fontWeight={600} textAlign="center" gutterBottom>
          Forgot your password?
        </Typography>

        <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ mb: 1 }}>
          Enter your email and we'll send you a link to reset it.
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 1 }}>
            {error}
          </Alert>
        )}

        {success && (
          <Alert severity="success" sx={{ mb: 1 }}>
            {success}
          </Alert>
        )}

        {!success && (
          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              fullWidth
              size="small"
              label="Email Address"
              name="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              margin="normal"
              placeholder="Enter your email"
              sx={{
                mb: 0,
                "& input::placeholder": { fontSize: "14px" },
              }}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailOutlined sx={{ fontSize: 18, color: "lightgrey" }} />
                    </InputAdornment>
                  ),
                },
              }}
            />

            <Button
              fullWidth
              type="submit"
              variant="contained"
              size="large"
              disabled={loading}
              sx={{ height: 38, borderRadius: 2, textTransform: "none", mt: 2 }}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : "Send reset link"}
            </Button>
          </Box>
        )}

        <Typography variant="body2" textAlign="center" color="text.secondary" sx={{ mt: 3 }}>
          Remembered your password?{" "}
          <Link href="/" underline="hover" fontWeight={600}>
            Sign in
          </Link>
        </Typography>
      </Paper>
    </Box>
  );
};

export default ForgotPassword;